import { METRICS } from '@/lib/constants/metrics'
import type { IconKey } from '@/components/ui/iconRegistry'

export type CreatorCategory = {
  iconKey: IconKey
  en: string
  fa: string
}

export type NetworkStat = {
  val: number
  suf: string
  en: string
  fa: string
}

export const creatorCategories: CreatorCategory[] = [
  { iconKey: 'fashion', en: 'Lifestyle & Fashion', fa: 'لایف‌استایل و فشن' },
  { iconKey: 'food', en: 'Food & Cooking', fa: 'آشپزی' },
  { iconKey: 'travel', en: 'Travel & Tourism', fa: 'سفر و گردشگری' },
  { iconKey: 'tech', en: 'Technology', fa: 'تکنولوژی' },
  { iconKey: 'sports', en: 'Sports & Health', fa: 'ورزش و سلامتی' },
  { iconKey: 'education', en: 'Educational', fa: 'آموزشی و علمی' },
  { iconKey: 'entertainment', en: 'Entertainment', fa: 'سرگرمی' },
  { iconKey: 'mommy', en: 'Mommy Blogger', fa: 'مامی بلاگر' },
  { iconKey: 'music', en: 'Music & Podcast', fa: 'موزیک و پادکست' },
  { iconKey: 'beauty', en: 'Beauty & Skincare', fa: 'زیبایی و مراقبت' },
  { iconKey: 'finance', en: 'Finance & Business', fa: 'مالی و کسب‌وکار' },
  { iconKey: 'pets', en: 'Pets & Animals', fa: 'حیوانات خانگی' },
]

export const networkStats: NetworkStat[] = [
  { val: METRICS.totalCreators.value, suf: '+', ...METRICS.totalCreators.label },
  { val: 12, suf: '', en: 'Categories', fa: 'دسته‌بندی' },
  { val: 31, suf: '', en: 'Provinces Covered', fa: 'استان تحت پوشش' },
  { val: 200, suf: 'K', en: 'Max Followers (Micro)', fa: 'حداکثر فالوور (میکرو)' },
]
